function sortDataTable(datatable, column) {
  return datatable.sort((a, b) => {
    if (column.order === "descending") {
      return String(b[column.prop]).localeCompare(a[column.prop], "pt-BR", {
        numeric: true,
      });
    } else if (column.order === "ascending") {
      return String(a[column.prop]).localeCompare(b[column.prop], "pt-BR", {
        numeric: true,
      });
    }
  });
}
export default sortDataTable;
